module.exports = __webpack_public_path__ + "static/media/info-customer.66c2a2e6.jpeg";